<template>
	<div id="payment-method"></div>
</template>

<script>
const clientKey = "test_gck_kYG57Eba3G47JwLpPbmlVpWDOxmA";
const paymentWidget = PaymentWidget(clientKey, PaymentWidget.ANONYMOUS);

export default {
	mounted() {
	},
	props: {
		paymentAmount: null
	},
	data() {
		return {
			order: null,
			orderId: null,
			orderName: null,
			customerEmail: null,
			customerName: null,

			paymentMethodsWidget: null
		}
	},
	methods: {
		init() {
			this.paymentMethodsWidget = paymentWidget.renderPaymentMethods("#payment-method", { value: this.paymentAmount }, { variantKey: "DEFAULT" });
		},
		clickPaymentButton() {
			paymentWidget.requestPayment({
				orderId: this.orderId,
				orderName: this.orderName,
				successUrl: window.location.origin + "/api/plugins/toss/pay/success",
				failUrl: window.location.origin + "/api/plugins/toss/pay/fail",
				customerEmail: this.customerEmail, // 고객 이메일 (선택)
				customerName: this.customerName, // 고객 이름 (선택)
				taxFreeAmount : this.order.isDeduction ? this.paymentAmount : 0,
				appScheme: "daehanbooksapp://"
			})
			.then((v) => console.log(v));
		},
	},
	watch: {
		paymentAmount() {
			this.paymentMethodsWidget.updateAmount(this.paymentAmount)
		}
	}
};
</script>